import { db } from "./firebase";
import {
  collection, addDoc, getDocs, updateDoc, deleteDoc,
  doc, query, where, orderBy, serverTimestamp
} from "firebase/firestore";

const COL = "requests";

export const REQUEST_SERVICES = [
  { id: "bubble_wrap",     label: "Bubble wrap",      price: 2,  icon: "🫧" },
  { id: "content_photos",  label: "3 content photos", price: 3,  icon: "📸" },
  { id: "extra_box",       label: "Extra box",        price: 5,  icon: "📦" },
  { id: "return_package",  label: "Return package",   price: 7,  icon: "↩️" },
  { id: "report_mistake",  label: "Report mistake",   price: 0,  icon: "⚠️" },
  { id: "other",           label: "Other",            price: 0,  icon: "✏️" },
];

export async function createRequest(data) {
  return await addDoc(collection(db, COL), {
    customerEmail:  data.customerEmail.toLowerCase().trim(),
    customerName:   data.customerName,
    packageId:      data.packageId || "",
    packageDesc:    data.packageDesc || "",
    services:       data.services,   // array of service ids
    totalCost:      data.totalCost,
    note:           data.note || "",
    status:         "Pending",       // Pending | In Progress | Completed | Rejected
    adminNotes:     "",
    createdAt:      serverTimestamp(),
    updatedAt:      serverTimestamp(),
  });
}

export async function getCustomerRequests(email) {
  const q = query(
    collection(db, COL),
    where("customerEmail", "==", email.toLowerCase().trim()),
    orderBy("createdAt", "desc")
  );
  const snap = await getDocs(q);
  return snap.docs.map(d => ({ id: d.id, ...d.data() }));
}

export async function getAllRequests() {
  const q    = query(collection(db, COL), orderBy("createdAt", "desc"));
  const snap = await getDocs(q);
  return snap.docs.map(d => ({ id: d.id, ...d.data() }));
}

export async function updateRequest(id, status, adminNotes) {
  await updateDoc(doc(db, COL, id), {
    status,
    adminNotes: adminNotes || "",
    updatedAt:  serverTimestamp(),
  });
}

export async function deleteRequest(id) {
  await deleteDoc(doc(db, COL, id));
}
